import { getCore } from '../../../client/core/getCore';
import { getDefaultClient } from '../../../client/defaultClient';
import { createApiClient } from '../../apiClient';
import { logout } from '../../auth/logout';

/**
 * Deletes the current user's account permanently.
 *
 * This function performs a hard delete of the user account. Upon successful deletion,
 * the user will be automatically logged out and all authentication data will be cleared.
 *
 * @param [client] - The Dynamic client instance. Only required when using multiple Dynamic clients.
 * @returns A promise that resolves when the user account is successfully deleted.
 */
export const deleteUser = async (
  client = getDefaultClient()
): Promise<void> => {
  const core = getCore(client);
  const apiClient = createApiClient({ includeMfaToken: true }, client);

  await apiClient.hardDeleteUser({
    environmentId: core.environmentId,
  });

  await logout(client);
};

